import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Registry } from '@/registry.service';
import { DialogPopUpComponent } from '@components/dialog-pop-up/dialog-pop-up.component';
import { LoggerService } from '@services/logger.service';
import { Component, OnInit } from '@angular/core';
import { ButtonComponent } from '@components/button/button.component';
import { ToastrService } from 'ngx-toastr';
import { BigBuyersService } from '@services/data-source-tables/big-buyers.service';
import { BigBuyersModel } from '@/models/tables/big-buyers.model';

@Component({
  selector: 'app-button-big-buyers-delete',
  templateUrl: '../../button.component.html',
  styleUrls: ['../../button.component.scss'],
})
export class ButtonDeleteBigBuyersComponent extends ButtonComponent implements OnInit {
  faIcon = faTrashCan;
  private bigBuyersModel: BigBuyersModel;
  private rowData: any;

  constructor(
    protected router: Router,
    public dialog: MatDialog,
    protected bigBuyersService: BigBuyersService,
    protected toastr: ToastrService,
  ) {
    super(router, toastr);

    this.color = 'danger';
    this.additionalClass = 'py-0.5 px-2.5';
    this.showIcon = true;
    this.smallBtn = true;
  }

  ngOnInit() {
    this.bigBuyersModel = <BigBuyersModel>this.rowData;
  }

  /**
   * Delete user
   */
  public actionClick(): void {
    let dialogRef = this.dialog.open(DialogPopUpComponent, {
      width: 'auto',
      panelClass: 'custom-modalbox',
    });

    this.setupPopup(dialogRef);

    dialogRef.afterClosed().subscribe((deleteBigBuyers) => {
      if (deleteBigBuyers) {
        this.bigBuyersService.deleteBigBuyers(this.bigBuyersModel.id).subscribe({
          next: () => {
            this.toastr.success('Grande acquirente cancellato correttamente!');

            Registry.getInstance().get('BigBuyersComponent').loadBigBuyers();
          },
          error: (error) => {
            LoggerService.error('deleteBigBuyers failed!');
            LoggerService.error(error);

            this.toastr.error(`Errore durante la cancellazione del Grande acquirente.`);
          },
          complete: () => {
            LoggerService.log('Request done');
          },
        });
      }
    });
  }

  private setupPopup(dialogRef: MatDialogRef<DialogPopUpComponent>) {
    dialogRef.componentInstance.title = 'Confermi di voler cancellare questo Grande acquirente?';
    dialogRef.componentInstance.content =
      'Attenzione una volta cancellata il Grande acquirente non sarà più possibile recuperarlo.';
    dialogRef.componentInstance.firstCTA = 'Si cancella';
    dialogRef.componentInstance.secondCTA = 'Annulla operazione';
    dialogRef.componentInstance.closeResultFirst = true;
    dialogRef.componentInstance.closeResultSecond = false;
  }
}
